// Use this with useGetOwnerModules' `get`
export const SmartModule = {
  PartnerFirstWalk: 'Partner First Walk',
  SittingAndBoarding: 'Sitting and Boarding',
  PersistentChat: 'Persistent Chat',
  LockboxPurchase: 'Lockbox Purchase',
  SocialDistancing: 'Social Distancing',
  DigitalTraining: 'Digital Training',
  WagHealth: 'Wag! Health'
};